<template>
  <div>
    <el-form :model="form" ref="form" :rules="rules" label-position="top">
      <el-form-item :label="$t('text.name')" prop="Name">
        <el-input
          v-model="form.Name"
          autocomplete="off"
          :placeholder="$t('text.name')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.alias')" prop="Alias">
        <el-input
          v-model="form.Alias"
          autocomplete="off"
          :placeholder="$t('text.alias')"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        PatientId: '',
        Alias: '',
        Name: ''
      },
      rules: this.initRules()
    }
  },
  methods: {
    initRules() {
      return {
        Alias: [
          {
            required: true,
            message: this.$t('text.please_enter_patient_alias'),
            trigger: 'blur'
          }
        ],
        Name: [
          {
            required: true,
            message: this.$t('text.please_enter_patient_name'),
            trigger: 'blur'
          }
        ]
      }
    }
  }
}
</script>
